import { api } from ".";
import {
  APiQueryBase,
  APiQueryJSONBase,
  ApiResponseBase,
} from "../interfaces/ApiResponseBase";
import { ErrorResult } from "../interfaces/ErrorResult";
import { Sensor, SensorFilter } from "../interfaces/Sensors";
import { isErrorResult } from "../utils/api";

export interface ISetVehicleEntry {
  license_plate: string;
  sensor_id: string;
}
export class SensorsService {
  static async get({
    filter,
    page,
    order,
  }: APiQueryBase): Promise<ApiResponseBase<Sensor[]> | ErrorResult> {
    return await api
      .get("/api/v2/sensors", {
        params: {
          page,
          per_page: 10,
          filter: JSON.stringify(filter),
          order: JSON.stringify(order),
        },
      })
      .then((r) => r.data)
      .catch((e) => e?.response?.data);
  }
  static async getVehiclesSensors({
    filter,
    page,
    order,
  }: APiQueryBase): Promise<ApiResponseBase<Sensor[]> | ErrorResult> {
    return await api
      .get("/api/v2/sensors/index-sensor-vehicle", {
        params: {
          page,
          per_page: 10,
          filter: JSON.stringify(filter),
          order: JSON.stringify(order),
        },
      })
      .then((r) => r.data)
      .catch((e) => e?.response?.data);
  }
  static async getWithFilter({
    filter,
    page,
  }: APiQueryJSONBase<any>): Promise<ApiResponseBase<any[]> | ErrorResult> {
    return await api
      .get(`/api/v2/sensors?page=${page}`, {
        params: {
          page,
          per_page: 10,
          filter: JSON.stringify(filter),
        },
      })
      .then((r) => r.data)
      .catch((e) => e?.response?.data);
  }

  static async loadSensorsOptions(
    search: string,
    loadedOptions: any,
    additional?: any
  ) {
    const { page } = additional;

    const response = await this.getWithFilter({
      filter: { search: search },
      page,
    });
    const options: any = {
      options: [],
      hasMore: false,
      additional: {
        page: 1,
      },
    };

    if (isErrorResult(response)) return options;

    const data = response.data;

    options.options = data?.map((d) => ({
      label: `${d.sensor_id} - ${d?.type?.description}`,
      value: d.sensor_id,
    }));

    options.hasMore =
      (response.meta && response.meta.current_page < response.meta.last_page) ||
      false;
    options.additional = {
      page: Number(page) + 1,
    };

    return options;
  }

  static async setVehicle({ license_plate, sensor_id }: ISetVehicleEntry) {
    return await api.post(`/api/v2/sensors/set-vehicle`, {
      license_plate,
      sensor_id,
    });
  }
  static async create({ payload }: any) {
    return await api.post(`/api/v2/sensors/store-sensor`, payload);
  }
}

export class SensorService {
  static async get({
    sensor_id,
    page,
    order,
    filter,
  }: SensorFilter): Promise<ApiResponseBase<Sensor[]> | ErrorResult> {
    return await api
      .get(`/api/v2/sensors/${sensor_id}`, {
        params: {
          page,
          per_page: 10,
          filter: JSON.stringify(filter),
          order: JSON.stringify(order),
        },
      })
      .then((r) => r.data)
      .catch((e) => e?.response?.data);
  }
}

export class SensorChart {
  static async get({
    sensor_id,
    order,
    filter,
  }: SensorFilter): Promise<ApiResponseBase<Sensor[]> | ErrorResult> {
    return await api
      .get(`/api/v2/sensors/get-chart-data`, {
        params: {
          sensor_id: sensor_id,
          order: JSON.stringify(order),
          filter: JSON.stringify(filter),
        },
      })
      .then((r) => r.data)
      .catch((e) => e?.response?.data);
  }
}
